/*
This is a template for environment configuration.

Copy this file and rename it to `environment.ts` for development or/and `environment.prod.ts` for production (set production to true).
Update the values as needed for each environment.
*/
export const environment = {
    production: true,

    // Sentry
    sentryDsn: 'https://074054befa82a9dc1dc4c2feee2b4d42@o4508562526961664.ingest.de.sentry.io/4508562559664208',
    sentryTracePropagationTargets: ["localhost", "https://app.neox.energy"],

    // API
    apiUrl: 'https://app.neox.energy/api', // Base API URL (ensure no trailing slash to avoid URL formatting issues)
    wsUrl: 'wss://app.neox.energy/ws',
    clientId: 'web_app',
    clientSecret: 'rLAdYjm4ZHyTKSTHYMftVEbH8ndWhLGQ',

    sessionTokenExcludedUrls: ['solar.googleapis.com', 'lh3.googleusercontent.com', 'amazonaws.com'],
    authTokenExcludedUrls: ['solar.googleapis.com', 'lh3.googleusercontent.com', 'amazonaws.com'],

    googleSolarApiKey: 'AIzaSyDfURuqRD5ybibZvKetFKBtXYPhEgllWCQ',

    // Stripe
    stripePublishableKey: 'pk_live_51QrzGxBMzC08FT9w5IfYRvQ0YKaBIorTcs4q7g38Glh63DAeoOxqorpMZwAL7xSPaFNsl3CQ7yAltT1pICUGgpES001gFAqJN5',

    // Terms
    termsAndConditions: 'https://www.neox.energy/terms/',

    // Policy
    privacyPolicy: 'https://www.neox.energy/privacy/'
};
